import React from 'react';
import { COLOR, RADIUS, SHADOW } from './tokens';

// White card container with an optional titled header. Body padding is
// applied by default; pass padded={false} for cards that hold tables or
// other content that owns its own gutters.

const styles = {
  card: {
    background: COLOR.surface,
    border: `1px solid ${COLOR.rule}`,
    borderRadius: RADIUS.lg,
    boxShadow: SHADOW.card,
    marginBottom: 20,
    overflow: 'hidden',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 18px',
    borderBottom: `1px solid ${COLOR.rule}`,
    background: COLOR.subtle,
    gap: 12,
    flexWrap: 'wrap',
  },
  title: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    color: '#374151',
    fontWeight: 600,
    fontSize: '0.9rem',
    margin: 0,
  },
  body: {
    padding: 18,
  },
};

export default function Card({
  title,
  headerRight,
  padded = true,
  scrollX = false,
  children,
  style,
  bodyStyle,
}) {
  const baseBody = padded ? { ...styles.body, ...bodyStyle } : bodyStyle;
  // scrollX wraps the body in an overflow-x:auto region so wide tables
  // scroll horizontally inside the card instead of overflowing it.
  const bodyProps = scrollX
    ? { style: { ...(baseBody || {}), overflowX: 'auto', WebkitOverflowScrolling: 'touch' } }
    : { style: baseBody };
  return (
    <section style={{ ...styles.card, ...style }}>
      {(title || headerRight) && (
        <div style={styles.header}>
          {title && <h2 style={styles.title}>{title}</h2>}
          {headerRight}
        </div>
      )}
      <div {...bodyProps}>{children}</div>
    </section>
  );
}
